import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconComments: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{
      color: COLORS.CERULEAN,
      
    }}
  >
    <path
      d="M20.29 6.96V18.93L19.77 18.42L17.96 16.64C17.79 16.47 17.56 16.38 17.33 16.38H7.99L6.83 17.52C7.33 17.94 7.97 18.18 8.62 18.18H16.96L17.05 18.27L20.56 21.74C20.73 21.91 20.96 22 21.19 22C21.31 22 21.43 21.98 21.55 21.93C21.88 21.79 22.1 21.46 22.1 21.1V9.56C22.1 8.4 21.37 7.36 20.3 6.96H20.29Z"
      stroke="none"
      fill="currentColor"
    />
    <path
      d="M15.63 14.56C17.16 14.56 18.4 13.32 18.4 11.79V5.94C18.4 4.41 17.16 3.17 15.63 3.17H4.87001C3.34001 3.17 2.10001 4.41 2.10001 5.94V17.48C2.10001 17.84 2.32001 18.17 2.66001 18.32C2.76001 18.37 2.88001 18.39 3.01001 18.39C3.25001 18.39 3.48001 18.3 3.64001 18.13L7.15001 14.66L7.24001 14.57H15.64L15.63 14.56ZM6.86001 12.75C6.62001 12.75 6.39001 12.84 6.22001 13.01L4.42001 14.79L3.90001 15.3V5.93C3.90001 5.4 4.33001 4.97 4.86001 4.97H15.63C16.16 4.97 16.59 5.4 16.59 5.93V11.79C16.59 12.32 16.16 12.75 15.63 12.75H6.86001Z"
      stroke="none"
      fill="currentColor"
    />
    
  </SvgIcon>
)
